var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStack = function SvgIconStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.504 1.386a1 1 0 0 0-1.008 0l-9 5.25a1 1 0 0 0 0 1.728l9 5.25a1 1 0 0 0 1.008 0l9-5.25a1 1 0 0 0 0-1.728zM12 11.592 4.985 7.5 12 3.408 19.015 7.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.136 11.496a1 1 0 0 1 1.368-.36L12 16.092l8.496-4.956a1 1 0 1 1 1.008 1.728l-9 5.25a1 1 0 0 1-1.008 0l-9-5.25a1 1 0 0 1-.36-1.368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.136 15.996a1 1 0 0 1 1.368-.36L12 20.592l8.496-4.956a1 1 0 1 1 1.008 1.728l-9 5.25a1 1 0 0 1-1.008 0l-9-5.25a1 1 0 0 1-.36-1.368"
  }))));
};
export default SvgIconStack;